export const ERROR_CODE_MESSAGES = {
  131026: 'Non WhatsApp.',
  131031: 'Account Blocked',
  131042: 'Payment Issue',
  131047: 'Re-engagement timeout',
  131049: 'Blocked by Anti-Spam Policy',
  131050: 'User Blocked',
  131056: 'Pair rate limit hit',
  130472: 'Experimental/Test Number',
};

